import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionType } from 'utils/constants';

import utils from 'utils';
import actions from 'state/actions';
import selectors from 'state/selectors';

import CommonButton from 'components/Buttons/CommonButton';

const CloneCompany = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const selectedCompany = useSelector(selectors.configurator.getSelectedCompany);

  return (
    <CommonButton
      id="clone-company"
      action={() => dispatch(actions.configurator.setFormModeCompany('clone'))}
      disabled={!selectedCompany || !utils.user.isActionByCompanyActive(actionType.CLONE_COMPANY, selectedCompany.name)}
      scope="tertiary"
      value={t('clone-company')}
      customIcon="copy"
    />
  );
};

export default CloneCompany;
